import { motion } from "framer-motion";
import React from "react";
import { adds } from "../../../assets";
import Button from "../../../components/Button";
import "./index.css";

const JoinUs = ({ variants }) => {
    return (
        <div className="joinus section relative">
            <img className="blur blur1" src={adds.blur1} alt="Blur" />

            <div className="container-lg flex flexCol alignCenter textCenter">
                <motion.h5
                    variants={variants}
                    initial={"initial"}
                    whileInView={"ani"}
                    viewport={{ once: true }}
                    custom={0.3}
                >
                    Careers
                </motion.h5>
                <motion.h2
                    variants={variants}
                    initial={"initial"}
                    whileInView={"ani"}
                    viewport={{ once: true }}
                    custom={0.6}
                >
                    Join Us
                </motion.h2>
                <motion.p
                    variants={variants}
                    initial={"initial"}
                    whileInView={"ani"}
                    viewport={{ once: true }}
                    custom={0.9}
                    className="parDes"
                >
                    Explore our career opportunities and join our team of AI experts.
                </motion.p>
                <Button
                    color={"white"}
                    text={"View careers"}
                    href={"https://vfgconsulting.peopleforce.io/careers"}
                    type={"external"}
                    variants={variants}
                    delay={1.2}
                />
            </div>
        </div>
    );
};

export default JoinUs;
